import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { hasProviderProfileSelector } from '../../../../redux/context/selectors';
import {
  selectSignAppointmentConsentLoading,
  selectSignAppointmentConsentSucceed,
} from '../../../../redux/healthboard/selectors';
import { actions as signAppointmentConsentActions } from '../../../../redux/healthboard/requests/sign-appointment-consent-req';

const mapStateToProps = state => ({
  providerContext: hasProviderProfileSelector(state),
  isSignConsentLoading: selectSignAppointmentConsentLoading(state),
  isSignConsentSucceed: selectSignAppointmentConsentSucceed(state),
});

const mapDispatchToProps = {
  signAppointmentConsent: signAppointmentConsentActions.send,
  clearSignConsentData: signAppointmentConsentActions.clear,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/ElectronicConsentPopup/enhance.jsx